import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=1c571a77&scoped=true"
import script from "./PublishModal.vue?vue&type=script&lang=js"
export * from "./PublishModal.vue?vue&type=script&lang=js"
import style0 from "./PublishModal.vue?vue&type=style&index=0&id=1c571a77&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c571a77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c571a77')) {
      api.createRecord('1c571a77', component.options)
    } else {
      api.reload('1c571a77', component.options)
    }
    module.hot.accept("./PublishModal.vue?vue&type=template&id=1c571a77&scoped=true", function () {
      api.rerender('1c571a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/PublishModal.vue"
export default component.exports